<template lang="html">
  <div class="has-dropdown" :class="{'is-active': active}" @click="toggle" v-on-clickaway="close">
    <slot/>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'

export default {
  directives: {
    onClickaway
  },

  data(){
    return {
      active: false
    }
  },

  methods: {
    toggle(){
      this.active = !this.active
    },

    close(){
      this.active = false
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/NavbarDropdown.vue